<template>
    <div class="main policeLato">
        <div v-responsive.lg.xl class="pt-5">
             <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
             <section>
                <div class="mt-5 paralax-cover-image has-background-dim">
                    <div class="paralax-cover-image-text">
                    <div class="content_home" style="z-index: 1!important;">
                        <h1 style="text-align:left;font-size: 70px" class="font-weight-bold"><span style="color: #fff">{{ $t('devis.devis_voyage.header_title[0]') }}</span></h1>
                        <h1 style="text-align:left;font-size: 70px;margin-top: -30px" class="font-weight-bold"><span style="color: #ffa409" class="ml-1">{{ $t('devis.devis_voyage.header_title[1]') }}</span></h1>
                    </div>
                </div>
                </div>
            </section>
        </div>
        <div v-responsive.sm.xs class="pt-5">
             <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
             <section>
                <div class="paralax-cover-image_mobile has-background-dim_mobile">
                    <p class="paralax-cover-image-text_mobile">
                        <div class="content_home" style="z-index: 1!important;margin-top: 10%">
                            <h1 style="font-size: 40px" class="font-weight-bold"><span style="color: #fff">{{ $t('devis.devis_voyage.header_title[0]') }}</span></h1>
                            <h1 style="font-size: 40px;margin-top: -20px;color: #ffa409" class="font-weight-bold"><span>{{ $t('devis.devis_voyage.header_title[1]') }}</span></h1>
                        </div>
                    </p>
                </div>
            </section>
        </div>
        <!-- <banner title="Devis Voyage" image-path="assurance/voyage.jpg"></banner> -->

        <slogan></slogan>

        <div class="container-view">
            <Stepper :active="activeStep" finish-status="success">
                <StepperItem title="Voyage" finish-status="success"></StepperItem>
                <StepperItem title="Passager"></StepperItem>
                <StepperItem title="Validation"></StepperItem>
            </Stepper>

            <travel-component v-if="activeStep === 0"></travel-component>
            <PassengerComponent v-else-if="activeStep === 1"></PassengerComponent>
            <ValidationComponent v-else></ValidationComponent>
        </div>

        <login-form :visible="showLoginForm" @close="showLoginForm=false"></login-form>
    </div>
</template>

<script>
import PassengerComponent from '../components/devis/Voyage/PassengerComponent.vue'
import TravelComponent from '../components/devis/Voyage/TravelComponent.vue'
import ValidationComponent from '../components/devis/Voyage/ValidationComponent.vue'
import StepperItem from '../components/layouts/Stepper/StepperItem.vue'
import Stepper from '../components/layouts/Stepper/Steppers.vue'
import Slogan from '../components/layouts/texts/slogan.vue'
import LoginForm from '../components/auth/Login.vue'
import { mapState, mapMutations } from 'vuex'
import Api from '../services/Api'

export default {
    name: 'DevisVoyageViews',
    components: {
        Stepper,
        StepperItem,
        Slogan,
        TravelComponent,
        PassengerComponent,
        ValidationComponent,
        LoginForm
    },
    data() {
        return {
            showLoginForm: false
        }
    },
    computed: {
        ...mapState({
            activeStep: 'activeStepper'
        })
    },
    methods: {
        ...mapMutations([
            'resetStepper',
            'resetContainerDevisVoyage'
        ]),
        displayLogginDialog() {
            if (!this.$store.state.isUserLoggedIn) this.showLoginForm = true
        },
        checkToken() {
            Api().get('user/check/token')
            .then((resultat) => {
            // verifie si le token exist
            if (!resultat.data.ok) {
                this.$store.state.isUserLoggedIn = false;
                this.$store.dispatch("setUser", {});
                this.$store.dispatch("setToken", {});
                this.showLoginForm = true
                }
            }).catch((err) => {
                // verifie  si le token est expiré
                if(err.response.data.ok === false){
                this.$store.state.isUserLoggedIn = false;
                this.$store.dispatch("setUser", {});
                this.$store.dispatch("setToken", {});
                this.showLoginForm = true
                }
            });
        },
    },
    mounted() {
        this.displayLogginDialog()
        this.checkToken()
        this.resetStepper()
        this.resetContainerDevisVoyage()
    },
}
</script>

<style scoped>
.main {
    background-color: #fafafa;
}

.container-view {
    padding: 0 15%;
}


.paralax-cover-image {
        background-image: url('../assets/img/assurance/voyage.jpg');
        position: relative;
        background-size: contain!important;
        background-position: 50%;
        min-height: 210px;
        width: 100%;
        margin: 0 0 0;
        display: flex;
        /*padding: 20px;*/
        align-items: center;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;

    }
    .paralax-cover-image p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
    }

    .paralax-cover-image .paralax-cover-image-text,
    .paralax-cover-image h2 {
        color: #fff;
        font-size: 2em;
        line-height: 1.25;
        z-index: 1;
        margin-bottom: 0;
        max-width: 610px;
        text-align: center;
        margin-left: 8.5%;
    }

    .paralax-cover-image.has-background-dim:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .paralax-cover-image {
        background-attachment: fixed;
        background-position: 50% 50px;
    }


  .paralax-cover-image_mobile {
        background-image: url('../assets/img/assurance/voyage_mobile.jpg');
        position: relative;
        background-size: contain;
        background-position: 50%;
        min-height: 150px;
        width: 100%;
        margin: 0 0 0;
        display: flex;
       /*padding: 20px;*/
        align-items: center;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;

    }
    .paralax-cover-image_mobile p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
        padding-bottom: 20Px;
    }

    .paralax-cover-image_mobile .paralax-cover-image-text_mobile,
    .paralax-cover-image_mobile h2 {
        color: #fff;
        font-size: 2em;
        line-height: 1.25;
        z-index: 1;
        margin-bottom: 0;
        max-width: 610px;
        text-align: center;
        margin-left: 8.5%;
    }

    .paralax-cover-image_mobile.has-background-dim_mobile:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .paralax-cover-image_mobile {
        /* background-attachment: fixed; */
        background-position: 100% 40px;
    }
</style>
